import { useContext } from 'react';
import { CompanyContext } from '@/app/shared/contexts/CompanyContext';

export const useCompany = () => {
  const context = useContext(CompanyContext);
  if (!context) {
    throw new Error('useCompany must be used within CompanyProvider');
  }
  return context;
};